import React from "react";
import {
  Alert,
  App as AntApp,
  Button,
  Card,
  Divider,
  Flex,
  Form,
  Input,
  Typography,
} from "antd";
import { LockOutlined, MailOutlined } from "@ant-design/icons";
import { useLogin } from "@refinedev/core";

type LoginValues = {
  email: string;
  password: string;
};

export const LoginPage: React.FC = () => {
  const [form] = Form.useForm<LoginValues>();
  const { message } = AntApp.useApp();
  const { mutate: login, isLoading } = useLogin<LoginValues>();

  const handleFinish = (values: LoginValues) => {
    login(values, {
      onError: (error) => {
        console.error("登录失败", error);
        message.error("登录失败，请检查邮箱或密码");
      },
      onSuccess: () => {
        message.success("登录成功，欢迎回来");
      },
    });
  };

  return (
    <Flex
      vertical
      justify="center"
      align="center"
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg,#eef5ff,#f7fbff)",
        padding: 24,
      }}
    >
      <Card
        style={{
          width: 440,
          borderRadius: 24,
          boxShadow: "0 35px 70px rgba(10,29,54,0.15)",
        }}
        title={
          <div style={{ textAlign: "center" }}>
            <Typography.Title level={3} style={{ marginBottom: 4 }}>
              夜光宝盒 · 管理登录
            </Typography.Title>
            <Typography.Text type="secondary">
              使用企业邮箱登录，即可进入运营工作台
            </Typography.Text>
          </div>
        }
      >
        <Alert
          type="info"
          message="没有账号？"
          description={
            <Typography.Paragraph style={{ marginBottom: 0 }}>
              参考仓库内的《admin-dashboard/ACCESS_GUIDE.md》在 Supabase 创建管理员，
              或联系运营负责人开通账号。
            </Typography.Paragraph>
          }
          style={{ marginBottom: 16 }}
          showIcon
        />
        <Form
          form={form}
          layout="vertical"
          onFinish={handleFinish}
          requiredMark={false}
        >
          <Form.Item
            label="邮箱"
            name="email"
            rules={[
              { required: true, message: "请输入邮箱" },
              { type: "email", message: "请输入正确的邮箱格式" },
            ]}
          >
            <Input
              size="large"
              prefix={<MailOutlined style={{ color: "#94a3b8" }} />}
              placeholder="you@example.com"
            />
          </Form.Item>

          <Form.Item
            label="密码"
            name="password"
            rules={[{ required: true, message: "请输入密码" }]}
          >
            <Input.Password
              size="large"
              prefix={<LockOutlined style={{ color: "#94a3b8" }} />}
              placeholder="请输入密码"
            />
          </Form.Item>

          <Button
            type="primary"
            htmlType="submit"
            size="large"
            block
            loading={isLoading}
          >
            登录
          </Button>
        </Form>
        <Divider />
        <Typography.Paragraph style={{ textAlign: "center", marginBottom: 0 }}>
          登录即表示你同意内部运营规范，并确保账号安全。
        </Typography.Paragraph>
      </Card>
    </Flex>
  );
};
